import { useEffect, useRef, useState } from "react";
import { WifiOff } from "lucide-react";
import { toast } from "sonner";

// Shows an offline bar; when the connection returns, reloads once so every page shows fresh data
export default function OfflineIndicator() {
  const [offline, setOffline] = useState(typeof navigator !== "undefined" && !navigator.onLine);
  const wasOffline = useRef(offline);

  useEffect(() => {
    const goOffline = () => { wasOffline.current = true; setOffline(true); };
    const goOnline = () => {
      setOffline(false);
      if (!wasOffline.current) return;
      wasOffline.current = false;
      toast.success("Connessione ripristinata · aggiorno i dati…");
      setTimeout(() => window.location.reload(), 1200);
    };
    window.addEventListener("offline", goOffline);
    window.addEventListener("online", goOnline);
    return () => { window.removeEventListener("offline", goOffline); window.removeEventListener("online", goOnline); };
  }, []);

  if (!offline) return null;
  return (
    <div data-testid="offline-indicator" role="status" className="fixed top-0 inset-x-0 z-[80] flex items-center justify-center gap-2 bg-[#FBBC05] text-black text-xs font-bold uppercase tracking-widest py-2 px-4 text-center animate-in slide-in-from-top duration-300">
      <WifiOff className="w-4 h-4 shrink-0" /> Sei offline · stai vedendo gli ultimi dati salvati. Prenotazioni e pagamenti richiedono la connessione.
    </div>
  );
}
